import OTilesPagination from './o-tiles-pagination';

export default OTilesPagination;